const o = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Top Records Icon</title><desc>Shows records positioned at the top.</desc><path d="M12 14l4 4h-3v4h-2v-4H8zm0-8H8v2h4zm4 4H8v2h8zm2-8H6a2 2 0 00-2 2v16a2 2 0 002 2h3v-2H6V4h12v16h-3v2h3a2 2 0 002-2V4a2 2 0 00-2-2z"/></svg>';
export {
  o as default
};
